import * as React from "react";

import { ordinalColors } from "src/constants/CouncilOrdinals";
import CouncilIdentityBadge, { ICouncilIdentityBadge } from "src/components/general/CouncilIdentity";

interface IProps {
  label: string;
  value: string|number;
  radius: number;
  ordinal: number;
}

export default class Bubble extends React.PureComponent<
IProps,
ICouncilIdentityBadge
> {

  public render() {
    const colors = ordinalColors[this.props.ordinal];
    const radius = this.props.radius || 80;
    const offsetX = 450;
    const offsetY = 25;

    let transformation;
    const margin = .5 * this.props.ordinal;
    switch (this.props.ordinal) {
      case 1:
        transformation = `translate(${offsetX + radius / 2}, ${offsetY + radius / 2})`;
        break;
      case 2:
        // transformation = `translate(${offsetX + radius * 2 + (2 * border)}, ${offsetY + 75})`;
        transformation = `translate(${offsetX * 1.5}, ${offsetY + 100 - radius })`;
        break;
      case 3:
        // transformation = `translate(${offsetX + radius * 2}, ${offsetY + radius * 2})`;
          transformation = `translate(${offsetX * 1.55 }, ${offsetY + 250 - radius })`;
        break;
      case 4:
        // transformation = `translate(${offsetX - radius * .4}, ${offsetY + radius * 1.5})`;
        transformation = `translate(${offsetX * 1.1}, ${offsetY + 300 - radius})`;
        break;
      default:
        transformation = `translate(${offsetX}, 0)`;
        break;
    }

    return (
      <div className="c-bubble"
        style={{
          transform: transformation
        }}>
        <div className="c-bubble__visual-data">
          <p 
            className="c-bubble__visual"
            style={{
              backgroundColor: colors.primary,
              borderColor: colors.secondary,
              color: colors.text,
              width: radius + 'em',
              height: radius + 'em',
              marginTop: margin + 'em',
              marginBottom: margin + 'em',
            }}>
            <span className="c-bubble__value font-bold">{ this.props.value }</span>
          </p>
        </div>    
        <div className="c-bubble__badge"
          style={{
            borderColor: colors.primary,
          }}
        >
          <CouncilIdentityBadge 
            name={ this.props.label }
            badge={ this.props.ordinal }
          />
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/report/councilFinances/BubbleChart/Bubble.tsx